import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { ColumnSemantic, Presentation } from "@lala/harness/protocol";

import { ChartLazy } from "../components/ChartLazy.tsx";

const METRIC_SEMANTICS = new Set<ColumnSemantic>([
  "currency",
  "percentage",
  "duration_days",
  "count",
]);

/**
 * `intent: "ranking"`: barras horizontales, delegadas en `<ChartLazy>` -- la
 * misma que usa un `ui_component` de la herramienta -- así se reusa su toggle
 * "ver tabla" (que a su vez reusa `DataTable`) sin duplicar esa lógica, y
 * ECharts sigue cargando solo cuando aparece el primer gráfico.
 */
export function Ranking({ presentation }: { presentation: Presentation }) {
  const categoryColumn = presentation.columns.find(
    (column) => column.semantic === "label" || column.semantic === "entity_id",
  );
  const valueColumn = presentation.columns.find((column) =>
    METRIC_SEMANTICS.has(column.semantic),
  );

  if (categoryColumn === undefined || valueColumn === undefined) {
    return (
      <Alert variant="destructive">
        <AlertTitle>Ranking mal formado</AlertTitle>
        <AlertDescription>
          No encontré una columna de categoría (label/entity_id) y una numérica
          para ordenar.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <ChartLazy
      props={{
        datasetId: presentation.datasetId,
        type: "bar_horizontal",
        title: null,
        categoryKey: categoryColumn.name,
        categoryLabel: categoryColumn.label,
        valueLabel: valueColumn.label,
        series: [{ key: valueColumn.name, label: valueColumn.label }],
        emphasisKey: null,
        // `ChartSpec` lo declara pero `Chart.tsx` no lo usa hoy para dibujar.
        rowCount: 0,
      }}
    />
  );
}
